import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import PrivateRouts from './PrivateRouts';
import { DEFAULT_LOCAL_PATH } from '../constents';
import Layout from '../components/Layouts/Layout';
import Scheduler from '../components/Schedular';
import Patient from '../components/Patient';
import Profile from '../components/Patient/Profile';
import Documents from '../components/Documents';
import Notes from '../components/Notes';
import Intake from '../components/Patient/Intake';
import PriorAuth from '../components/PriorAuth';
import Report from '../components/Report/Index';
import Communication from '../components/Communication';
import Login from '../components/Auths/Login';
import NotFound from '../NotFound';
import Referral from '../components/Patient/Referral';

// Define your routes using React Router's new API
const router = createBrowserRouter(
  [
    {
      element: <PrivateRouts />,
      children: [
        {
          path: `${DEFAULT_LOCAL_PATH}/scheduler`,
          element: <Layout />,
          children: [{ index: true, element: <Scheduler /> }],
        },
        {
          path: `${DEFAULT_LOCAL_PATH}/patient`,
          element: <Layout />,
          children: [
            { index: true, element: <Patient /> },
            { path: ':page', element: <Profile /> },
            { path: ':page/:patientId', element: <Profile /> },
            { path: ':page/:patientId/:appId', element: <Profile /> },
            { path: ':page/:patientId/:appId/:visitId', element: <Profile /> },
            {
              path: ':page/:patientId/:appId/:visitId/:treatmentId',
              element: <Profile />,
            },
            { path: 'intake', element: <Intake /> },
            { path: 'referral', element: <Referral /> },
          ],
        },
        {
          path: `${DEFAULT_LOCAL_PATH}/documents`,
          element: <Layout />,
          children: [{ index: true, element: <Documents /> }],
        },
        {
          path: `${DEFAULT_LOCAL_PATH}/notes`,
          element: <Layout />,
          children: [
            { index: true, element: <Notes /> },
            { path: ':page', element: <Notes /> },
            { path: ':page/:type', element: <Notes /> },
          ],
        },
        {
          path: `${DEFAULT_LOCAL_PATH}/priorAuth`,
          element: <Layout />,
          children: [{ index: true, element: <PriorAuth /> }],
        },
        {
          path: `${DEFAULT_LOCAL_PATH}/report`,
          element: <Layout />,
          children: [
            { index: true, element: <Report /> },
            { path: 'credentialing', element: <Report /> },
          ],
        },
        {
          path: `${DEFAULT_LOCAL_PATH}/communication`,
          element: <Layout />,
          children: [{ index: true, element: <Communication /> }],
        },
      ],
    },
    { path: `${DEFAULT_LOCAL_PATH}`, element: <Login /> },
    { path: '*', element: <NotFound /> },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

function AppRoutes() {
  return <RouterProvider router={router} />;
}

export default AppRoutes;
